import React from "react";
import { SomaSeal } from "../components/SomaMarks";

/* Shared shell for cafe-portal pages (signup / login / dashboard). */
export function CafeShell({ children, testId }) {
  return (
    <div
      className="page"
      data-testid={testId}
      style={{
        maxWidth: 560,
        margin: "0 auto",
        minHeight: "100vh",
        padding: "44px 24px 80px",
        position: "relative",
      }}
    >
      <div className="grain" />
      <div className="vignette" />
      <div className="scanlines" />
      <header style={{ textAlign: "center", marginBottom: 32 }}>
        <p className="section-marker" style={{ textAlign: "center", marginBottom: 16 }}>cafe.partners</p>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 14, color: "var(--terracotta-soft)" }}>
          <SomaSeal size={62} />
        </div>
        <h1 className="brand-wordmark" style={{ fontSize: 40, margin: 0, color: "var(--cream)" }}>
          SOMA <span style={{ fontStyle: "italic", color: "var(--terracotta-soft)" }}>Lixir</span>
        </h1>
        <div className="hairline" />
      </header>
      {children}
    </div>
  );
}

export function Field({ label, children, hint }) {
  return (
    <label style={{ display: "block", marginBottom: 16 }}>
      <span style={{
        display: "block",
        fontFamily: "'Space Mono', monospace",
        fontSize: 10,
        letterSpacing: "0.24em",
        textTransform: "uppercase",
        color: "var(--terracotta-soft)",
        marginBottom: 8,
      }}>{`// ${label}`}</span>
      {children}
      {hint && (
        <span style={{
          display: "block",
          marginTop: 6,
          fontSize: 13,
          color: "var(--dim)",
          fontFamily: "'IM Fell DW Pica', serif",
          fontStyle: "italic",
        }}>{hint}</span>
      )}
    </label>
  );
}

export const inputStyle = {
  width: "100%",
  border: "1px solid rgba(143, 196, 224, 0.32)",
  borderRadius: 0,
  padding: "12px 16px",
  fontFamily: "'Space Mono', monospace",
  fontSize: 14,
  color: "var(--cream)",
  background: "rgba(255, 255, 255, 0.025)",
  outline: "none",
};
